/** Switch existing editor panes on compact screens; desktop retains every pane. */
export function editorPanels(
  host: HTMLElement,
  panes: Array<{ key: string; label: string; element: HTMLElement }>,
  initial: string,
  onChange: (key: string) => void = () => undefined,
): HTMLElement {
  host.dataset.mobilePane = initial;
  const nav = document.createElement("nav");
  nav.className = "city-editor-pane-nav";
  nav.setAttribute("aria-label", "بخش‌های ویرایشگر");
  const buttons: HTMLButtonElement[] = [];
  for (const pane of panes) {
    pane.element.dataset.editorPane = pane.key;
    const button = document.createElement("button");
    button.type = "button";
    button.textContent = pane.label;
    button.dataset.pane = pane.key;
    button.setAttribute("aria-pressed", String(pane.key === initial));
    button.addEventListener("click", () => {
      host.dataset.mobilePane = pane.key;
      buttons.forEach(item => item.setAttribute("aria-pressed", String(item === button)));
      onChange(pane.key);
    });
    buttons.push(button);
    nav.appendChild(button);
  }
  return nav;
}
